import React, { Component } from 'react';

import Table from '../../../../facturotopia/table/Table';
import EmisorSerieListItemActions from './EmisorSerieListItemActions';

class EmisorSeriesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selectedRowKeys: [],
    };
  }

  get columns() {
    return [
      {
        key: 'tipo',
        title: 'Tipo',
        dataIndex: 'tipo',
      },
      {
        key: 'serie',
        title: 'Serie',
        dataIndex: 'serie',
      },
      {
        key: 'folio',
        title: 'Folio',
        dataIndex: 'folio',
      },
    ];
  }

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  handleOnDeleteRequest = () => {
    const { selectedRowKeys } = this.state;
    const { data: all } = this.props;

    let series = all.map((item) => {
      const newItem = { ...item };

      newItem.action = selectedRowKeys.indexOf(newItem?.id) !== -1 ? 'delete' : undefined;

      return newItem;
    });

    this.props.onDataChange(series);

    this.setState({
      selectedRowKeys: [],
    });
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  render() {
    const { columns, selectedRowKeys } = this.state;
    const { data = [] } = this.props;

    return (
      <>
        <div className="text-right mb-3">
          {selectedRowKeys.length > 0 && <EmisorSerieListItemActions onDeleteRequest={this.handleOnDeleteRequest} />}
        </div>

        <Table
          columns={columns}
          rowKey={'id'}
          data={data.filter((item) => item.action !== 'delete')}
          rowSelection={{
            selectedRowKeys,
            ...this.getRowSelectionConfig(),
          }}
        ></Table>
      </>
    );
  }
}

export default EmisorSeriesList;
